module.exports = __webpack_public_path__ + "img/event_1.05546c00.jpg";